import React from 'react';
import Skeleton from '../skeleton/skeleton';
import './title-description.scss';

export default function TitleDescriptionLoader() {
  return (
    <div className="title-description-container">
      <h4 className="title">
        <Skeleton skHeight="0.833vw" skWidth="60%" marginBottom="0.694vw" />
      </h4>

      <p className="description">
        <Skeleton skHeight="0.694vw" skWidth="95%" />
      </p>
    </div>
  );
}
